import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { StringValue } from "./StringValue";
import { StringArray } from "./StringArray";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Open SCHS Maps">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Atk Hero"}
          value={task.taskstatusdetail.atkheroname}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Currently Running Map:"}
          value={task.taskstatusdetail.currentmap}
        />
        <StringValue
          label={"Total Scored:"}
          value={task.taskstatusdetail.totalScoreBillions}
        />
        <StringArray
          label={"Report:"}
          array={task.taskstatusdetail.report}
          valueParser={(item) =>
            item.levelname +
            "(Score:" +
            item.score +
            ")(bestScore:" +
            item.bestscore +
            ")(LifeLeft:" +
            item.lifeleft +
            ")"
          }
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
